import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { cardSx, cardLgSx, cardHoverSx } from './pvtaStyles';

interface PvtaCardProps {
    /** Größerer Radius (lg) statt Standard (md). */
    large?: boolean;
    /** Hover-Anhebung (Desktop) + Press-Feedback (Mobile) für klickbare Cards. */
    interactive?: boolean;
    onClick?: () => void;
    sx?: SxProps<Theme>;
    className?: string;
    children: React.ReactNode;
}

/**
 * Generische weiße PVTA-Card (Radius/Border/Schatten/Padding).
 * Vereinheitlicht die zuvor pro Seite duplizierten cardSx-Objekte.
 *
 * Der eingehende sx-Prop wird über die MUI-Array-Form gemerged (nicht
 * gespreadet), da SxProps eine Union (Objekt | Funktion | Array) ist.
 */
const PvtaCard: React.FC<PvtaCardProps> = ({
    large = false,
    interactive = false,
    onClick,
    sx,
    className,
    children,
}) => (
    <Box
        className={className}
        onClick={onClick}
        sx={[
            large ? cardLgSx : cardSx,
            interactive ? cardHoverSx : false,
            interactive ? { '&:active': { transform: 'scale(0.995)' }, cursor: 'pointer' } : false,
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    >
        {children}
    </Box>
);

export default PvtaCard;
